import { useEffect, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { defaultCardDataTest } from "./CardListTest"
import { IMG } from "../../../Commons/Functions"

export default function FocusedCardMenu({ focusedCard, applyChanges, updateCardId, showDeleteCardModal, customCardData }) {
    const defaultCardData = { ...defaultCardDataTest }
    const [focusedCardValue, setFocusedCardValue] = useState(false)

    useEffect(() => {
        if (focusedCard) {
            setFocusedCardValue(focusedCard.value)
        } else {
            setFocusedCardValue(false)
        }
    }, [focusedCard])

    function changeCardData(key, newValue) {
        // Autre fonciton pour le id ?
        let tmp = { ...focusedCardValue }
        tmp[key] = newValue
        setFocusedCardValue(tmp)
        console.log(key, newValue)
        applyChanges(tmp)
    }

    function changeCardFrontData(key, newValue) {
        let tmp = { ...focusedCardValue }
        tmp.face.front[key] = newValue
        setFocusedCardValue(tmp)
        applyChanges(tmp)
    }

    function changeCardBackData(key, newValue) {
        let tmp = { ...focusedCardValue }
        if (key === "DELETE_FACE") {
            delete tmp.face.back
        } else {
            tmp.face.back[key] = newValue
        }
        setFocusedCardValue(tmp)
        applyChanges(tmp)
    }

    if (!focusedCardValue) { return }

    return (<div className='d-flex flex-column'>
        <div className='d-flex justify-content-between mb-3'>
            <h1>{focusedCardValue.name}</h1>
            <Button variant='secondary' className="mb-auto text-nowrap" onClick={() => showDeleteCardModal()}>Delete card</Button>
        </div>
        <div className='box-container'>
            <div className="w-100">
                <Field value={focusedCard.key} title="Card Id" type={defaultCardData.id.type} changeCardData={(k, v) => {
                    updateCardId(v)
                }} />
            </div>
        </div>
        <div className='box-container'>
            <div className="w-100">
                <Field fieldKey="isToken" value={focusedCardValue.isToken} title="Is card a token" type={defaultCardData.isToken.type} changeCardData={changeCardData} />
            </div>
        </div>

        <h5 className='mt-4'>Game data</h5>
        <p>Data for both face, used while playing. Those values are never used in the deckbuilding section.</p>
        <Row className=''>
            <Col xs={6}>
                <FaceData
                    face={"FRONT"}
                    data={focusedCardValue.face.front}
                    defaultFaceData={defaultCardData.face}
                    changeCardData={changeCardFrontData}
                    customCardData={customCardData}
                />
            </Col>
            <Col xs={6}>
                {focusedCardValue.face.back && (<FaceData
                    face={"BACK"}
                    data={focusedCardValue.face.back}
                    defaultFaceData={defaultCardData.face}
                    changeCardData={changeCardBackData}
                    customCardData={customCardData}
                />)}
                {!focusedCardValue.face.back && (
                    <div className='d-flex align-items-center justify-content-center w-100 h-100'>
                        <Button onClick={() => {
                            let tmp = { ...focusedCardValue }
                            tmp.face.back = {
                                "name": "",
                                "type": "",
                                "cost": 0,
                                "image": "",
                                "isHorizontal": false
                            }
                            setFocusedCardValue(tmp)
                            applyChanges(tmp)
                        }}>Add card back</Button>
                    </div>)}
            </Col>
        </Row>

        <h5 className='mt-5'>Deckbuilder data</h5>
        <p>Only used in the deckbuilder when searching for cards. Use the 'Edit card data' button to add more fields for your cards.</p>
        <div className='d-flex flex-column box-container'>
            <Field fieldKey="name" value={focusedCardValue.name} title="Full name" type={defaultCardData.name.type} changeCardData={changeCardData} />
            <Field fieldKey="type" value={focusedCardValue.type} title="Default type" type={defaultCardData.type.type} changeCardData={changeCardData} customCardData={customCardData} />
            <Field fieldKey="cost" value={focusedCardValue.cost} title="Default cost" type={defaultCardData.cost.type} changeCardData={changeCardData} />
            {customCardData.customKeys.map((k, i) => {
                if (focusedCardValue[k.title]) {
                    return (<Field fieldKey={k.title} value={focusedCardValue[k.title]} title={k.title} type={k.type} changeCardData={changeCardData} />)
                } else {
                    // WHAT ABOUT IF EMPTY ????
                    return (<Field fieldKey={k.title} value={focusedCardValue[k.title]} title={k.title} type={k.type} changeCardData={changeCardData} />)
                }
            })}
        </div>
    </div>)
}

function FaceData(props) {
    const isFront = props.face === "FRONT"
    return (<div className='d-flex flex-column position-relative p-3 m-0 box-container'>
        <h3 className='text-center'>{isFront ? "Front" : "Back"}</h3>
        {!isFront && (<Button className='position-absolute top-0 end-0 m-3' onClick={() => {
            props.changeCardData("DELETE_FACE", true)
        }}>Delete</Button>)}
        <div className='mb-4'>
            <div className='face-image mx-auto my-3 position-relative'>
                {props.data.image != "" && (<IMG className="w-100 h-100" src={props.data.image} />)}
            </div>
            <Form.Control
                className='w-75 mx-auto'
                type="text"
                placeholder="Face image url"
                defaultValue={props.data.image}
                onChange={(e) => {
                    props.changeCardData("image", e.currentTarget.value)
                }}
            />
        </div>
        <div className='d-flex flex-column'>
            <Field fieldKey="name" value={props.data.name} title="Face name" type={props.defaultFaceData.name.type} changeCardData={props.changeCardData} />
            <Field fieldKey="type" value={props.data.type} title="Face type" type={props.defaultFaceData.type.type} changeCardData={props.changeCardData} customCardData={props.customCardData} />
            <Field fieldKey="cost" value={props.data.cost} title="Face cost" type={props.defaultFaceData.cost.type} changeCardData={props.changeCardData} />
            <Field fieldKey="isHorizontal" value={props.data.isHorizontal} title="Is face horizontal" type={props.defaultFaceData.isHorizontal.type} changeCardData={props.changeCardData} />
        </div>
    </div>)
}

function Field(props) {
    return (<div className='d-flex align-items-center my-1'>
        <p className='text-nowrap m-0 me-3 text-capitalize'>{props.title}</p>
        <FormField type={props.type} defaultValue={props.value} changeCardData={props.changeCardData} fieldKey={props.fieldKey} customCardData={props.customCardData} />
    </div>)
}

function FormField({ type, defaultValue, changeCardData, fieldKey, customCardData }) {
    if (type == "Text") {
        return (
            <Form.Control
                type="text"
                placeholder=""
                defaultValue={defaultValue}
                onChange={(e) => {
                    changeCardData(fieldKey, e.currentTarget.value)
                }}
            />
        )
    } else if (type == "Number") {
        return (
            <Form.Control
                type="number"
                placeholder=""
                defaultValue={defaultValue}
                onChange={(e) => {
                    changeCardData(fieldKey, e.currentTarget.value)
                }}
            />
        )
    } else if (type == "Bool") {
        return (
            <Form.Check
                type="switch"
                checked={defaultValue}
                onChange={(e) => {
                    changeCardData(fieldKey, !defaultValue)
                }}
                className='ms-auto'
            />
        )
    } else if (type == "Select") {
        return (
            <Form.Select
                defaultValue={defaultValue}
                onChange={(e) => {
                    changeCardData(fieldKey, e.currentTarget.value)
                }}
            >
                <option key={"UNDEFINED"} value={false}>Undefined</option>
                {customCardData.cardTypes.map((c, i) => {
                    return (<option key={c} value={c}>{c}</option>)
                })}
            </Form.Select>
        )
    } else if (type == "Text-Array") {
        return (
            <div className="d-flex flex-column w-100 align-items-end">
                {defaultValue && defaultValue.map((v, i) => {
                    return (
                        <div className="d-flex w-100" key={i}>
                            <Form.Control
                                type="text"
                                placeholder=""
                                defaultValue={v}
                                className="w-100"
                                onChange={(e) => {
                                    let tmp = [...defaultValue]
                                    tmp[i] = e.currentTarget.value
                                    changeCardData(fieldKey, tmp)
                                }}
                            />

                        </div>
                    )
                })}
                <div className="d-flex">
                    <Button onClick={() => {
                        let tmp = !defaultValue ? [] : [...defaultValue]
                        tmp.push("")
                        changeCardData(fieldKey, tmp)
                    }}>Add</Button>
                    {defaultValue && defaultValue.length > 0 && (<Button variant="secondary" onClick={() => {
                        let tmp = !defaultValue ? [] : [...defaultValue]
                        tmp.splice(tmp.length - 1, 1)
                        changeCardData(fieldKey, tmp)
                    }}>-</Button>)}
                </div>
            </div>
        )
    }
}